module.exports = __webpack_public_path__ + "static/media/portrait.9774e0a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/portrait.jpg
// module id = 36
// module chunks = 0